import {configureScope, init} from '@sentry/browser';
import {Dedupe, ExtraErrorData, SessionTiming} from '@sentry/integrations';
import {patchWixSdk} from '@wix/js-sdk-live-mock';
import {getAppVersion} from '@wix/music-shared/dist/src/wmp-shared/utils/env/getAppVersion';
import {getEnv} from '@wix/music-shared/dist/src/wmp-shared/utils/env/getEnv';
import 'reflect-metadata';
import {installUnhandled} from './logging/unhandled';
import {withMock} from './mock-environment/mock-environment';
import {getWixParams} from './statistics/getWixParams';

installUnhandled();

const appVersion = getAppVersion();

if (window.__STATICS_BASE_URL__) {
  // @ts-expect-error
  __webpack_public_path__ = window.__STATICS_BASE_URL__;
}

if (window.top === window) {
  patchWixSdk(window.Wix);
}
withMock();

init({
  dsn: 'https://371e4a17b4f64feca413a86c54e0497d@sentry.wixpress.com/152',
  release: `music-widget@${appVersion}`,
  environment: getEnv(),
  integrations: [new Dedupe(), new SessionTiming(), new ExtraErrorData()],
});

configureScope((scope) => {
  const {visitorId, instanceId, userId, compId, deviceType, viewMode, metaSiteId} = getWixParams();
  scope.setExtras({
    visitorId,
    instanceId,
    userId,
    compId,
    metaSiteId,
    referrer: document.referrer,
  });

  scope.setTags({
    deviceType: String(deviceType),
    viewMode: String(viewMode),
  });
  if (metaSiteId) {
    scope.setTag('msid', metaSiteId);
  }
});
